import React from 'react';
import { Row, Col, Label, Button } from 'react-bootstrap';
import { unescapeHTML } from 'underscore.string';
export default class ShipmentPaneHeader extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Row, { style: { paddingTop: 5 } },
            React.createElement(Col, { md: 10 },
                React.createElement("strong", null,
                    unescapeHTML(this.props.exception.shipment.shipper_name),
                    " - ",
                    this.props.exception.shipment.shipment_id)),
            React.createElement(Col, { md: 2 },
                React.createElement(Button, { bsStyle: "link", style: { float: "right" }, bsSize: "xsmall", onClick: this.props.closePane }, "X"))));
    }
}
